import Button from "@commons/Button";
import TableHeaderRoot from "./TableHeaderRoot";
import MapTableSelector from "./MapTableSelector";

const TableHeader = {
  Root: TableHeaderRoot,
  MapTableSelector: MapTableSelector,
  Button: Button,
};

export default TableHeader;
